import { IMenuItem } from 'src/components/Menu/type'

export const tarifs: IMenuItem = {
  title: 'Tarifs',
  href: '/tarifs/',
}
